/*
         * @ngdoc function
         * @name ePay.Model:Session_ApplePayModel
         * @description
         * Model
         */
import { Session_ApplePayShippingContactModel } from './Session_ApplePayShippingContactModel';
import { Session_ApplePayTokenModel } from './Session_ApplePayTokenModel';

export class Session_ApplePayModel {
	shippingContact: Session_ApplePayShippingContactModel;
	token: Session_ApplePayTokenModel;

	constructor(
		shippingContact?: Session_ApplePayShippingContactModel, 
		token?: Session_ApplePayTokenModel
	) {
		this.shippingContact = shippingContact || new Session_ApplePayShippingContactModel();
		this.token = token || new Session_ApplePayTokenModel();
	}
}
